import { useGetHeaderTitle } from "../../services/HeaderTitleContext";
import { Breadcrumbs, Anchor, Text } from "@mantine/core";
import { Link, useMatches } from "react-router-dom";

export const PageTitle = () => {
  const matches = useMatches();
  const customHeaderName = useGetHeaderTitle();

  const crumbs = matches
    .filter((match) => Boolean(match.handle?.name))
    .map((match, index, array) => {
      const isLast = index === array.length - 1;
      const name = match.handle.name;

      if (isLast) {
        return (
          <Text key={match.id} size="sm" fw={700}>
            {customHeaderName || name}
          </Text>
        );
      }

      return (
        <Anchor
          component={Link}
          to={match.pathname}
          key={match.id}
          size="sm"
          underline="hover"
          c="dimmed"
        >
          {name}
        </Anchor>
      );
    });

  if (crumbs.length === 0) {
    return (
      <Text size="sm" fw={700}>
        Dashboard
      </Text>
    );
  }

  return (
    <Breadcrumbs separator="/" separatorMargin="xs">
      {crumbs}
    </Breadcrumbs>
  );
};
